export function triggerDownload(url: string, filename: string): void {
  const anchor = document.createElement("a")

  anchor.href = url
  anchor.download = filename

  anchor.click()
}

export async function downloadMedia(url: string, filename?: string): Promise<void> {
  const response = await fetch(url)
  if (!response.ok) throw new Error("Failed to download media")

  const contentType = response.headers.get("content-type") || ""

  const blob = await response.blob()

  const urlParts = url.split("/").pop() || "download"
  const inferredName = urlParts.includes(".") ? urlParts.substring(0, urlParts.lastIndexOf(".")) : urlParts
  const baseName = filename || inferredName

  const extensionFromContent = contentType.split("/").pop()
  const extensionFromUrl = urlParts.includes(".") ? urlParts.split(".").pop() : null
  const extension = extensionFromContent || extensionFromUrl || "bin"

  const finalName = `${baseName}.${extension}`

  const objectUrl = URL.createObjectURL(blob)
  triggerDownload(objectUrl, finalName)
  URL.revokeObjectURL(objectUrl)
}
